// removed by extract-text-webpack-plugin
module.exports = {"container_0":"container_0___gxKi5","container_1":"container_1___2Eqnu","container_2":"container_2___2UeQ_"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Catalogue/styles.module.scss
// module id = 731
// module chunks = 0